export default __webpack_public_path__ + "assets/webgl/complete-26.8485bb5f.jpg";